<template>
    <CContainer fluid style="margin-bottom:100px;">
        <CHeader fixed with-subheader light style="max-height: 56px;">
            <img
                class="my-auto mfs-2"
                height="25" :alt="$t('affili')" src="//statics.affili.ir/storage/assets/logo/affili-signet.png"
            >
            <CHeaderNav class="mfe-auto">
                <CHeaderNavLink v-if="!['setup.tickets', 'setup.tickets.create', 'setup.tickets.details'].includes($route.name)" :to="{name: 'setup.tickets'}" class="text-primary text-underline">
                    <FaIcon icon="headset" class="mfe-1 position-relative"/>
                    پشتیبانی
                </CHeaderNavLink>
                <CHeaderNavLink v-else class="text-primary text-underline" :to="{name: currentSetupStep}">
                    <FaIcon icon="play" class="mfe-1 position-relative"/>
                    {{ $t('setup.continue') }}
                </CHeaderNavLink>
            </CHeaderNav>
            <CHeaderNav class="mfs-auto">
                <CHeaderNavLink :href="accountUrl" class="text-primary text-underline">
                    <FaIcon icon="cog" class="mfe-1 position-relative"/>
                    {{ $t('service_management.plural') }}
                </CHeaderNavLink>
            </CHeaderNav>
        </CHeader>

        <div class="mb-4"></div>

        <!-- Router View -->
        <router-view />
    </CContainer>
</template>

<script>
import { mapGetters } from 'vuex'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'Setup',

    data() {
        return {
            accountUrl: process.env.VUE_APP_BASE_OAUTH2 + '/panel/services',
        }
    },

    computed: {
        ...mapGetters({
            user: 'user/current',
        }),

        currentSetupStep() {
            const setupStatuses = {
                [UserSetupStatus.PERSONAL_INFO]: 'setup.steps.personal_information',
                [UserSetupStatus.FINANCIAL_INFO]: 'setup.steps.financial_information',
                [UserSetupStatus.MEDIA]: 'setup.steps.submit_media',
                [UserSetupStatus.ACTIVITY_AREA]: 'setup.steps.submit_activity_area',
                [UserSetupStatus.STORE_INFO]: 'setup.steps.store_information',
                [UserSetupStatus.IMPLEMENT_SCRIPT]: 'setup.steps.implement_script',
                [UserSetupStatus.SUBMIT_COMMISSION]: 'setup.steps.set_commission',
                [UserSetupStatus.CHARGE_ACCOUNT]: 'setup.steps.charge_account',
                [UserSetupStatus.ACCEPT_AGREEMENT]: 'setup.steps.accept_agreement',
                [UserSetupStatus.PENDING_TO_ACTIVE]: 'setup.steps.finish',
                [UserSetupStatus.SUSPENDED]: 'setup.steps.suspended',
            }

            return setupStatuses[this.user.setup_status]
        }
    },
}
</script>